module.exports = __webpack_public_path__ + "images/230a5f82001897035b2a6735d03f8fc3.png";